import type * as React from "react";
import { createContext } from "react";
import { useRequiredContext } from "~/hooks/index";
import type { ProjectTemplateStatusAction } from "./ProjectTemplateStatus/projectTemplateStatusActions";
import type { ProjectTemplateStatusState } from "./ProjectTemplateStatus/projectTemplateStatusReducer";
interface ProjectTemplateStatusContextValue {
    state: ProjectTemplateStatusState;
    dispatch: React.Dispatch<ProjectTemplateStatusAction>;
}
const ProjectTemplateStatusContext = createContext<ProjectTemplateStatusContextValue | undefined>(undefined);
export function useProjectTemplateStatusContext(): ProjectTemplateStatusContextValue {
    return useRequiredContext(ProjectTemplateStatusContext);
}
export const ProjectTemplateStatusContextProvider = ProjectTemplateStatusContext.Provider;
